var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable @typescript-eslint/naming-convention */
import { ElementController } from './ElementController.js';
import { CustomElement, Attribute, OnEvent } from '../utils/CustomElement.js';
const icon_vertical_alignmment = {
    '?': 1,
    '💡': 0,
    '📦': 0,
    '🧩': 0,
    '🌎': 0,
    '⛅': 1,
    '☀': 0,
    '⊡': 2
};
const DEBUG_LABEL = 'debug-label';
let DebugLabel = class DebugLabel extends HTMLElement {
    constructor() {
        super();
        this._context_menu = null;
        this.on_click = new Set();
        this.on_right_click = new Set();
        this.icon = '?';
        this.background = 'darkturquoise';
        this.x = '0';
        this.y = '0';
        this.squared = false;
        this._shadow = this.attachShadow({ mode: 'open' });
        this.render();
    }
    show_context_menu(content) {
        this.remove_context_menu();
        this._context_menu = document.createElement('ul');
        this._context_menu.classList.add('context-menu');
        this._context_menu.addEventListener('contextmenu', (e) => {
            e.preventDefault();
            this.remove_context_menu();
        });
        content.forEach(([name, callback]) => {
            var _a;
            const button = document.createElement('li');
            button.classList.add('context-menu-item');
            button.innerText = name;
            button.addEventListener('click', callback);
            (_a = this._context_menu) === null || _a === void 0 ? void 0 : _a.append(button);
        });
        this._shadow.append(this._context_menu);
    }
    remove_context_menu() {
        if (this._context_menu && this._shadow.contains(this._context_menu)) {
            this._shadow.removeChild(this._context_menu);
            this._context_menu = null;
        }
    }
    has_context_menu() {
        return !!this._context_menu;
    }
    on_click_handler() {
        this.on_click.forEach(callback => callback());
    }
    on_context_handler(e) {
        e.preventDefault();
        this.on_right_click.forEach(callback => callback());
    }
    render() {
        const left = Number(this.x) - 20;
        const top = Number(this.y) - 20;
        this._shadow.innerHTML =
            /* html */
            `
      <style>
        :host {
          display: flex;
          position: absolute;
          z-index: 9000;
          left: ${left}px;
          top: ${top}px;
          font-size: 1.6rem;
          opacity: 1;
        }
        .icon {
          font-size: 22px;
          display: flex;
          width: 40px;
          height: 40px;
          box-sizing: border-box;
          align-items: center;
          justify-content: center;
          padding-bottom: ${icon_vertical_alignmment[this.icon]}px;
          border-radius: ${this.squared ? '5px' : '25px'} ;
          background-color: ${this.background};
          pointer-events: auto;
          cursor: pointer;
        }
        .icon:hover {
          border: 1px solid white;
        }
        .context-menu {
          position: absolute;
          background-color: #a5a5de35;
          list-style: none;
          padding: 8px;
          border-radius: 8px;
          font-size: 12px;
          top: 32px;
          pointer-events: auto;
        }
        .context-menu-item {
          padding: 4px 12px;
          background-color: #a5a5de55;
          cursor: pointer;
          white-space: nowrap;
          min-width: 80px;
        }
        .context-menu-item:first-child {
          border-top-left-radius: 8px;
          border-top-right-radius: 8px;
        }
        .context-menu-item:last-child {
          border-bottom-left-radius: 8px;
          border-bottom-right-radius: 8px;
        }
        .context-menu-item:hover {
          background-color: ${this.background};
        }
      </style>
      <div class="icon">${this.icon}</div>
    `;
    }
};
__decorate([
    Attribute
], DebugLabel.prototype, "icon", void 0);
__decorate([
    Attribute
], DebugLabel.prototype, "background", void 0);
__decorate([
    Attribute
], DebugLabel.prototype, "x", void 0);
__decorate([
    Attribute
], DebugLabel.prototype, "y", void 0);
__decorate([
    Attribute
], DebugLabel.prototype, "squared", void 0);
__decorate([
    OnEvent('click', '.icon')
], DebugLabel.prototype, "on_click_handler", null);
__decorate([
    OnEvent('contextmenu', '.icon')
], DebugLabel.prototype, "on_context_handler", null);
DebugLabel = __decorate([
    CustomElement(DEBUG_LABEL)
], DebugLabel);
export { DebugLabel };
export class DebugLabelController extends ElementController {
    constructor(parent) {
        super(parent, DEBUG_LABEL);
    }
    get on_click() {
        return this._element.on_click;
    }
    get on_right_click() {
        return this._element.on_right_click;
    }
    click() {
        this._element.on_click.forEach(callback => callback());
    }
    show_context_menu(...args) {
        this._element.show_context_menu(...args);
    }
    remove_context_menu() {
        this._element.remove_context_menu();
    }
    has_context_menu() {
        return this._element.has_context_menu();
    }
    set_position(x, y) {
        const left = (x - 20) + 'px';
        const top = (y - 20) + 'px';
        this.style.left = left;
        this.style.top = top;
    }
    set_title(title) {
        this._element.title = title;
    }
    set_icon(icon) {
        this.set_attribute('icon', icon);
    }
}
//# sourceMappingURL=DebugLabel.js.map